import { Organization } from '@yuno/types'
import { useEffect, useState } from 'react'
import { storage, Item } from '../lib/storage'

export const useAccount = () => {
  const [account, setAccount] = useState<Organization.Account>()

  useEffect(() => {
    const accountListener = (account: Organization.Account) => {
      setAccount(account)
    }

    storage.on(Item.ACCOUNT, accountListener)

    setAccount(storage.getItem<Organization.Account>(Item.ACCOUNT))

    return () => {
      storage.off(Item.ACCOUNT, accountListener)
    }
  }, [])

  return account
}
